interface Props {
  status: 'none' | 'draft' | 'signed';
  onClick?: (e: React.MouseEvent) => void;
}

const STYLES: Record<'none' | 'draft' | 'signed', React.CSSProperties> = {
  none:   { background: '#edf2f7', color: '#4a5568', border: '1px solid #cbd5e0' },
  draft:  { background: '#fef5e7', color: '#975a16', border: '1px solid #f6ad55' },
  signed: { background: '#f0fff4', color: '#22543d', border: '1px solid #68d391' },
};

const LABELS: Record<'none' | 'draft' | 'signed', string> = {
  none:   'Create',
  draft:  'Draft',
  signed: 'Signed',
};

export default function ReportBadge({ status, onClick }: Props) {
  const s = STYLES[status] ?? STYLES.none;
  const label = LABELS[status] ?? LABELS.none;
  return (
    <button
      onClick={onClick}
      title={status === 'signed' ? 'View signed report' : status === 'draft' ? 'Modify draft report' : 'Create report'}
      style={{
        ...s,
        padding: '3px 10px',
        borderRadius: 10,
        fontSize: 11,
        fontWeight: 600,
        cursor: 'pointer',
      }}
    >
      {label}
    </button>
  );
}
